import { ReactComponent as HelpCenterIcon } from "../icons/BurgerMenuIcons/HelpCenterIcon.svg";
import { ReactComponent as SubmitTagsIcon } from "../icons/BurgerMenuIcons/SubmitTagsIcon.svg";
import { ReactComponent as GuidelinesIcon } from "../icons/BurgerMenuIcons/GuidelinesIcon.svg";
import { ReactComponent as FAQIcon } from "../icons/BurgerMenuIcons/FAQIcon.svg";
import { ReactComponent as TermsIcon } from "../icons/BurgerMenuIcons/TermsIcon.svg";
import { ReactComponent as PrivacyIcon } from "../icons/BurgerMenuIcons/PrivacyIcon.svg";
import { ReactComponent as DMCAIcon } from "../icons/BurgerMenuIcons/DMCAIcon.svg";
import { ReactComponent as StatementIcon } from "../icons/BurgerMenuIcons/StatementIcon.svg";
import { ReactComponent as RGCams } from "../icons/BurgerMenuIcons/RGCams.svg";

const BurgerMenuIcons = {
  HelpCenterIcon,
  SubmitTagsIcon,
  GuidelinesIcon,
  FAQIcon,
  TermsIcon,
  PrivacyIcon,
  DMCAIcon,
  StatementIcon,
  RGCams
};

export default BurgerMenuIcons;
